<template>
  <div class="container products-wrap px-2 py-2 border">
      <div class="title-wrap border-bottom mb-3">
        <h1>{{$ml.with('VueJS').get('PCProductsModeration')}}</h1>
      </div>

      <div class="submit-list-form-wrap d-flex flex-wrap">
          <div class="col-6 col-md-6 mb-2">
              <b-form-file
                      v-model="form.file"
                      :placeholder="$ml.with('VueJS').get('SelectFileOrDragHere')"
                      :drop-placeholder="$ml.with('VueJS').get('DropHere')"
                      :browse-text="$ml.with('VueJS').get('Browse')"
                      :multiple="false"
              ></b-form-file>
          </div>
          <div class="col-6 col-md-3 mb-2">
              <b-form-select v-model="pharmCompanyId" :options="availablePharmCompanies"></b-form-select>
          </div>
          <div class="col-12 col-md-3 mb-2">
              <b-button variant="success" @click="sendProductsList()" class="w-100" :disabled="isLoading">{{$ml.with('VueJS').get('Send')}}</b-button>
          </div>
      </div>

      <div class="list-wrap" v-if="itemsList.length > 0">
          <b-table
                  striped
                  hover
                  small
                  id="products-list"
                  :items="itemsList"
                  :fields="fields"
          >
              <template v-slot:cell(createdAt)="row">
                  {{row.item.createdAt}}
              </template>
              <template v-slot:cell(actions)="row">
                  <a v-bind:href="`${row.item.downloadLink}`" target="_blank">
                      <font-awesome-icon icon="download"></font-awesome-icon>
                  </a>
              </template>
          </b-table>
      </div>
  </div>
</template>

<style>
    .b-form-file {
        overflow: hidden;
    }
</style>
<script>
  import axios from 'axios'
  import mixinUtils from "@/components/mixinUtils";
  import { apiRoot } from "@/helpers/variables";

  export default {
    name: 'pharm-company-products-upload',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
      form: {
        file: null,
      },
      fields: [
        {
          key: 'fileName',
          label: 'Файл',
          sortable: false
        },
          {
              key: 'createdAt',
              label: 'Дата создания',
              sortable: true,
          },
        {
          key: 'actions',
          label: '',
          sortable: false
        },
      ],
      pharmCompanyId: null,
      pharmCompaniesList: [],
      itemsList: [],
      isLoading: false,
    }),
    methods: {
      sendProductsList () {
        const contex = this
        if (contex.isLoading) return;

        if (!this.pharmCompanyId || !this.form.file) {
          contex.$bvToast.toast(contex.$ml.with('VueJS').get('RequiredFieldsAreEmpty'), {
            title: contex.$ml.with('VueJS').get('PharmCompanyProducts'),
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: false,
            toaster: 'b-toaster-bottom-right',
          })

          return;
        }

        // upload file
        const formData = new FormData()
        formData.append('xlsFile', this.form.file, this.form.file.name)
        formData.append('pharmCompanyId', this.pharmCompanyId)
        contex.isLoading = true
        axios.post(`${apiRoot}products/upload-moderated`, formData, {
          withCredentials: false,
          crossdomain: true,
          headers: {
            Authorization: `Bearer ${this.$store.state.user.token}`,
          }
        }).then((res) => {
          if (res.status === 200 && res.data.file !== undefined) {
            contex.$bvToast.toast(contex.$ml.with('VueJS').get('ProductsListSuccessfullyUploaded'), {
              title: contex.$ml.with('VueJS').get('PharmCompanyProducts'),
              autoHideDelay: 5000,
              variant: 'success',
              appendToast: false,
              toaster: 'b-toaster-bottom-right',
            })
          } else {
            contex.$bvToast.toast(res.data.message, {
              title: contex.$ml.with('VueJS').get('PharmCompanyProducts'),
              autoHideDelay: 5000,
              variant: 'danger',
              appendToast: false,
              toaster: 'b-toaster-bottom-right',
            })
          }
        }).catch(function (error) {
              contex.$bvToast.toast(`${error.message}`, {
                title: contex.$ml.with('VueJS').get('PharmCompanyProducts'),
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
        }).finally(function () {
            contex.isLoading = false
        })
      },
      getItems () {
        const contex = this
        if (contex.isLoading) return;

        contex.isLoading = true
        contex.apiCall(`products/files?id=${contex.pharmCompanyId}`, 'post', {})
          .then(function (response) {
            if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно получены`, {
                title: 'Список продуктов ФК',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }

            contex.itemsList = []
            for (let i = 0; i < response.data.items.length; i++) {
              const data = response.data.items[i]
              contex.itemsList.push(data)
            }

            contex.isLoading = false
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      },
      getPharmcompanies () {
        const contex = this
        if (contex.isLoading) return;

        contex.isLoading = true
        contex.apiCall(`pharmcompany/index?page=1&per-page=10000`, 'post', {})
          .then(function (response) {
            if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно получены`, {
                title: 'Список фарм компаний',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }

            contex.pharmCompaniesList = []
            for (let i = 0; i < response.data.items.length; i++) {
              const data = response.data.items[i]
              contex.pharmCompaniesList.push(data)
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      }
    },
    mounted() {
      const context = this
      context.getPharmcompanies()
    },
    watch: {
      pharmCompanyId: {
        // eslint-disable-next-line no-unused-vars
        handler: function(newVal, oldVal) {
          this.getItems()
        }
      }
    },
    computed: {
      availablePharmCompanies () {
        const options = []
        for (let i = 0; i < this.pharmCompaniesList.length; i++) {
          const item = this.pharmCompaniesList[i]
          options.push({
            value: item.id,
            text: item.name,
          })
        }
        return options
      },
    }
  }
</script>